<div class="average-svg-container" #averageBox>
    <svg class="average-box" [attr.viewBox]="viewBox" preserveAspectRatio="none">
        <path class="average-box-body" [attr.d]="averageBoxPath" />
        <text class="lato-14-n-vw" x="50%" y="50%" text-anchor="middle" dominant-baseline="middle"
            alignment-baseline="middle">
            <tspan class="text-avg">AVG</tspan>
            <tspan class="avg-value" [ngClass]="className" dx="14">{{average.toFixed(1)}}</tspan>
            <tspan class="total-value">/{{total}}</tspan>
        </text>
    </svg>
</div>